import { render } from "./IntroText.vue?vue&type=template&id=30bbc608&scoped=true"
import script from "./IntroText.vue?vue&type=script&lang=js"
export * from "./IntroText.vue?vue&type=script&lang=js"

import "./IntroText.vue?vue&type=style&index=0&id=30bbc608&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bbc608"]])

export default __exports__